export class Client {
  constructor({ app, $api, store }) {
    this.app = app;
    this.api = $api;
    this.store = store;
  }

  get profile() {
    return this.store.getters['client/active'];
  }

  get application() {
    return this.store.state.client.application;
  }

  get loan() {
    return this.store.state.client.loan;
  }

  get hasActiveApplication() {
    const { status } = this.application;
    const {
      APPLICATION_COMPLETED,
      APPLICATION_CANCELED,
      APPLICATION_REJECTED,
      APPLICATION_TERMINATED,
    } = this.app.$tools.status;

    return Boolean(
      status &&
        ![
          APPLICATION_CANCELED,
          APPLICATION_COMPLETED,
          APPLICATION_REJECTED,
          APPLICATION_TERMINATED,
        ].includes(status)
    );
  }

  /**
   * Make search in ERP
   * For provided data
   * @param {object} payload
   * @returns {Promise}
   */

  find(payload) {
    return this.api.dispatch('client/find', payload);
  }

  /**
   * Send sms on provided
   * Phone Number
   * @param {string} payload
   * @returns {Promise}
   */

  sendSms(payload) {
    return this.api.dispatch('client/sendSms', payload);
  }

  /**
   * Send sms on provided Email
   * @param {string} payload
   * @returns {Promise}
   */

  sendEmail(payload) {
    return this.api.dispatch('client/sendEmail', payload);
  }

  /**
   * Creates client in ERP
   * @param {object} payload
   * @returns {Promise<void>}
   */

  async create(payload) {
    const { email: login, password } = payload;
    const response = await this.api.dispatch('client/create', payload);
    if (response.success) await this.app.$auth.login({ login, password });
    return response;
  }

  /**
   * Updates client in ERP
   * @param {object} payload
   * @returns {Promise}
   */

  async update(payload) {
    const response = await this.api.dispatch('client/update', payload);
    if (response.success) this.setData(response.data);
    return response;
  }

  /**
   * Setting data of client
   * @param {object} payload
   */

  setData(payload) {
    this.store.commit('auth/SET', { key: 'user', value: payload });
  }

  /**
   * Create Application in ERP
   * @param {object} payload
   * @returns {Promise}
   */

  createApplication(payload) {
    return this.store.dispatch('client/createApplication', payload);
  }

  /**
   * Get Actual Application
   * @returns {Promise}
   */

  getApplication() {
    return this.store.dispatch('client/getApplication');
  }

  /**
   * Get Actual Loan
   * @returns {Promise}
   */

  getLoan() {
    return this.store.dispatch('client/getLoan');
  }

  /**
   * Get Payment Schedule
   * @returns {Promise}
   */

  getActivePaymentSchedule() {
    return this.store.dispatch('client/getActivePaymentSchedule');
  }

  /**
   * Change Client mobilePhone
   * Number in ERP
   * @param {object} payload
   * @returns {Promise<void>}
   */

  async changePhone(payload) {
    const response = await this.api.dispatch('client/changePhone', payload);
    if (response.success) this.setData(response.data);
    return response;
  }

  /**
   * Change Client email in ERP
   * @param {object} payload
   * @returns {Promise<void>}
   */

  async changeEmail(payload) {
    const response = await this.api.dispatch('client/changeEmail', payload);
    if (response.success) this.setData(response.data);
    return response;
  }

  /**
   * Change Client password in ERP
   * @param {object} payload
   * @returns {Promise<void>}
   */

  async changePassword(payload) {
    const response = await this.api.dispatch('client/changePassword', payload);
    if (response.success) this.setData(response.data);
    return response;
  }

  /**
   * Upload Income details to ERP
   * @param {object} payload
   * @returns {promise}
   */

  uploadIncomeDetails(payload) {
    return this.api.dispatch('client/uploadIncomeDetails', payload);
  }

  /**
   * Approve Decrease offer
   * @returns {promise}
   */

  approveDecrease() {
    return this.store.dispatch('client/approveDecrease');
  }

  /**
   * Refuse Increase offer
   * @returns {promise}
   */

  refuseIncrease() {
    return this.store.dispatch('client/refuseIncrease');
  }

  /**
   * Approve Increase offer
   * @returns {promise}
   */

  approveIncrease() {
    return this.store.dispatch('client/approveIncrease');
  }

  /**
   * Recover Client password from ERP
   * @param {object} payload
   * @returns {promise}
   */

  recover(payload) {
    return this.api.dispatch('client/recover', payload);
  }

  /**
   * Download Document from ERP
   * @param {object} payload
   * @returns {promise}
   */

  downloadDocument(payload) {
    return this.api.dispatch('client/downloadDocument', payload);
  }

  /**
   * Approve new rollover type , email sending & consents.
   * @param {object} payload
   * @returns {promise}
   */

  triggerEmailSending(payload) {
    return this.api.dispatch('client/triggerEmailSending', payload);
  }

  /**
   * Save disbursement info
   * @param {object} payload
   * @returns {promise}
   */

  saveDisbursementType(payload) {
    return this.api.dispatch('client/saveDisbursementType', payload);
  }

  /**
   * Save OTP consent
   * @param {object} payload
   * @returns {promise}
   */

  saveSummaryConsent(payload) {
    const { id } = this.application;
    return this.api.dispatch('client/saveSummaryConsent', { id, payload });
  }

  /**
   * Get Application Payment Method
   * @returns {Promise}
   */

  getApplicationPaymentMethod() {
    return this.api.dispatch('client/getApplicationPaymentMethod');
  }
}

export default (ctx, inject) => {
  inject('client', new Client(ctx));
};
